export default __webpack_public_path__ + "static/media/trackinfo_overview.504ca724.avif";